export default "__VITE_ASSET__DjEAb97P__"